const greyScale = {
    transparent: 'transparent',
    black: '#262626',
    white: '#ffffff',
    grey: {
        100: '#fafafa',
        200: '#f2f2f2',
        300: '#e5e5e5',
        400: '#d2d2d2',
        500: '#989898',
        600: '#6f6f6f',
        700: '#56575b',
    },
}

const alphaColors = {
    alpha: {
        dark: {
            // or black
            10: 'rgba(0, 0, 0, 0.1)',
            15: 'rgba(0, 0, 0, 0.15)',
            20: 'rgba(0, 0, 0, 0.2)',
            30: 'rgba(0, 0, 0, 0.3)',
            40: 'rgba(38, 38, 38, 0.4)',
            50: 'rgba(0, 0, 0, 0.5)',
            70: 'rgba(38, 38, 38, 0.7)',
            '80b': 'rgba(0, 0, 0, 0.8)',
            80: 'rgba(38, 38, 38, 0.8)',
        },
        light: {
            // or white
            30: 'rgba(255, 255, 255, .3)',
            40: 'rgba(24, 10, 10, 0.4)',
            70: 'rgba(255, 255, 255, 0.7)',
            80: 'rgba(255, 255, 255, 0.8)',
            90: 'rgba(255, 255, 255, 0.9)',
        },
    },
}

const system = {
    success: '#3e6214',
    error: '#922222',
    alert: '#e07a0f',
    info: '#e8f0fe',
    alertMessage: {background: '#f8d7da', text: '#852e36', border: '#f5c6cb'},
}

const brand = {
    brown: {100: '#f1f0ef', 200: '#dfdbd8', 300: '#8d8277', 400: '#71685f'},
    green: {100: '#eef1f1', 200: '#ced4d3', 300: '#537876', 400: '#415857'},
    blue: {100: '#e6ecf2', 200: '#c6d2dc', 300: '#698196', 400: '#33485b'},
    pink: {100: '#fcf4f4', 200: '#f3e8e8', 300: '#d4c5c4', 400: '#a57b78'},
    orange: {100: '#f9f0ec', 200: '#ead1c7', 300: '#ce9a85', 400: '#a7674d'},
    teal: {300: '#50a29e'},
}

const colors = {
    ...greyScale,
    ...alphaColors,
    ...system,
    ...brand,
}

export default colors
